module.exports = __webpack_public_path__ + "static/img_1694-46eaca65bd3f138375d96548845358a6.webp";